import { render, staticRenderFns } from "./AuthorIntro.vue?vue&type=template&id=2debafb2&"
import script from "./AuthorIntro.vue?vue&type=script&lang=js&"
export * from "./AuthorIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports